/*global _:true*/

angular.module('b2bLoginApp').directive('sdDropdown', [function() {
    return {
        restrict: 'E',
        require: 'ngModel',
        scope: {collection: '=', map: '=', options: '=', dropdownId: '=', placeholder: '=', disabled:'=?', titles:'=?', sdRequired:'=?'},
        templateUrl: 'areas/dropdown.html',
        link: function(scope, el, attrs, ctrl) {
            scope.$on('sd-change', function(){
                if (scope.sdRequired) {
                    var allFalse =_.every(scope.collection, function(value) {
                        return value === false;
                    });
                    ctrl.$setValidity('required', !allFalse);
                }
                ctrl.$setDirty();
            });
        },
        controller: ["$scope", function($scope) {
            $scope.showLabel = function() {
                return _.every($scope.collection, function(value) {
                    return value === false;
                });
            };
            $scope.showOpenButton = function() {
                return _.some($scope.collection, function(value) {
                    return value === false || value === 'child';
                });
            };

            $scope.requestOpen = function(event) {
                if ($scope.disabled) {
                    return;
                }
                $scope.options.open = $scope.options.open === $scope.dropdownId ? null : $scope.dropdownId;
                event.stopPropagation();
            };
            $scope.onClickItem = function(key, value, $event) {
                if ($scope.collection[key] === true) {
                    $scope.collection[key] = false;
                    $scope.$emit('sd-change', [key, false]);
                } else if ($scope.collection[key] === false || $scope.collection[key] === 'child') {
                    $scope.collection[key] = true;
                    $scope.$emit('sd-change', [key, true]);
                } else if ($scope.collection[key] === 'parent') {
                    $scope.collection[key] = false;
                    $scope.$emit('sd-change', [key, 'child_deselect']);
                }
                if ($event) {
                    event.stopPropagation();
                }

                return false;
            };
            $scope.onRemove = function(key, $event) {
                $scope.collection[key] = false;
                $scope.$emit('sd-change', [key, false]);
                $event.stopPropagation();
            };
            $scope.showDrawer = function() {
                return $scope.options.open === $scope.dropdownId;
            };
        }]
    };
}]);
